class SaveProfileCategoriesDto {
  id?: string;
  category!: string;
}

export default SaveProfileCategoriesDto;
